import React from 'react'
import javascriptlogo from "../../javascript_logo.png"

const JavaScript = () => {
    return (
        <div style={{minHeight: 120}}>
            <div className="card card-body" style={{width: 300}}>
                <article >
                    <img  src={javascriptlogo} alt=""/>
                </article>
                Some placeholder content for the collapse component. This panel is hidden by default but revealed when the user activates the relevant trigger.
            </div>
        </div>
    )
}

export default JavaScript;
